module.exports = __webpack_public_path__ + "img/sectionsvg.90c6cb50.svg";